/* eslint-disable */

import React from 'react'
import { Redirect } from "react-router-dom";
// servicess
import authSvc from "services/authSvc";
const ProtectedRoutes = ({ children}) => {
  const currentUser = authSvc.currentUser();

  if (!currentUser) {
    return <Redirect to="/auth/login" replace />;
  }


  return children;
}

export default ProtectedRoutes